import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, isDevMode } from '@angular/core';
import { StorageService, StorageType } from '@rct/lynx-lobbies-shared-lib';
import { Observable } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { environment } from '../../../environments/environment';
import { LYNX_STORAGE_KEYS } from '../constants/lynx-storage-keys.constant';
import { LynxAuthService } from '../services/auth.service';

@Injectable()
export class LynxApiInterceptor implements HttpInterceptor {
  private readonly _apiPattern = RegExp(environment.url.interceptorRegExp);

  constructor(
    private authService: LynxAuthService,
    private storageService: StorageService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    isDevMode() &&
      console.log('Lynx API Interceptor Triggered:::', request.url);

    if (this._apiPattern.test(request.url)) {
      const lobbyId = this.storageService.get(
        LYNX_STORAGE_KEYS.lobbyId,
        StorageType.Session
      );
      if (!lobbyId) {
        this.authService.forceLogout();
      } else {
        if (this.authService.isLoggedIn) {
          const tokenObj = this.storageService.get(LYNX_STORAGE_KEYS.kioskToken);
          if (tokenObj) {
            request = request.clone({
              headers: request.headers
                .set('X-CorrelationId', uuidv4())
                .set('X-LobbyId', lobbyId)
                .set('Authorization', `Bearer ${tokenObj.kioskToken}`)
            });
          } else {
            this.authService.forceLogout();
          }
        } else {
          request = request.clone({
            headers: request.headers
              .set('X-CorrelationId', uuidv4())
              .set('X-LobbyId', lobbyId)
          });
        }
      }
    }
    return next.handle(request);
  }
}
